export default "<p>product-details-left works!</p>\n";